module.exports = __webpack_public_path__ + "img/tip.002c8868.png";